import script from "./PopoverCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopoverCard.vue?vue&type=script&setup=true&lang=ts"

import "./PopoverCard.vue?vue&type=style&index=0&id=2afc3e2e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2afc3e2e"]])

export default __exports__